module.exports = __webpack_public_path__ + "img/IMAGE12.914565a4.jpg";